module.exports = __webpack_public_path__ + "static/media/image_dashboard.8e2eda03.svg";